import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AdalGuard } from 'adal-angular4';
// import { AuthenticationGuard } from 'microsoft-adal-angular6';
import { MsalGuard } from '@azure/msal-angular';
import { PermissionGuard } from './core/guard/permission.guard';
import { AppComponent } from './app.component';



const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule),
    // canActivate: [AdalGuard]
    canActivate: [MsalGuard, PermissionGuard]
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    // { useHash: true }
    // { useHash: true }
{ useHash: false, relativeLinkResolution: 'legacy' },
   
  )],
  
  exports: [RouterModule]
})
export class AppRoutingModule {

  
 }
// export function isInIframe() {
//   return window !== window.parent && !window.opener;
// }



